import { render, staticRenderFns } from "./accounts-merge-icon.vue?vue&type=template&id=33ea2006"
import script from "./accounts-merge-icon.vue?vue&type=script&lang=js"
export * from "./accounts-merge-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports